import { render, staticRenderFns } from "./TollfreeDetail.vue?vue&type=template&id=22c8feda&scoped=true"
import script from "./TollfreeDetail.vue?vue&type=script&lang=js"
export * from "./TollfreeDetail.vue?vue&type=script&lang=js"
import style0 from "./TollfreeDetail.vue?vue&type=style&index=0&id=22c8feda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c8feda",
  null
  
)

export default component.exports